import React, { Suspense, useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { CSpinner } from '@coreui/react-pro';
import { setCurrentBaseId } from './states/modules/users';
import useFetchCurrentUser from './hooks/useFetchCurrentUser';
import './scss/style.scss';

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'));
const ProtectedRoute = React.lazy(() => import('./components/ProtectedRoute'));

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'));
const Register = React.lazy(() => import('./views/pages/register/Register'));
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'));
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'));
const Purchase = React.lazy(() => import('./views/pages/purchase'));

const loading = (
	<div className="pt-3 text-center">
		<div className="sk-spinner sk-spinner-pulse"></div>
	</div>
);

const App = () => {
	const dispatch = useDispatch();
	const { currentUser } = useFetchCurrentUser();

	useEffect(() => {
		if (currentUser?.baseId) {
			dispatch(setCurrentBaseId(currentUser?.baseId));
		}
	}, [dispatch, currentUser]);

	return (
		<BrowserRouter basename={process.env.PUBLIC_URL || '/'}>
			{/* <Suspense fallback={loading}> */}
			<Suspense fallback={<CSpinner color="primary" />}>
				<Routes>
					<Route exact path="/login" name="Login Page" element={<Login />} />
					<Route exact path="/register" name="Register Page" element={<Register />} />
					<Route exact path="/404" name="Page 404" element={<Page404 />} />
					<Route exact path="/500" name="Page 500" element={<Page500 />} />
					<Route
						exact
						path="/assinatura/:planName"
						name="Subscription Page"
						element={<Purchase />}
					/>
					<Route
						path="*"
						name="Home"
						element={
							<ProtectedRoute>
								<DefaultLayout />
							</ProtectedRoute>
						}
					/>
				</Routes>
			</Suspense>
		</BrowserRouter>
	);
};

export default App;
